export default "__VITE_ASSET__DGIwsdI1__"